import React from 'react';
import logo from './logo.svg';
import './App.css';
import HamburgerMenu from './Components/HamburgerMenu';
import { BrowserRouter , Routes,  Route, Link } from "react-router-dom";
import Page_Index from './Components/Page_Index';
import Page_Contact from './Components/Page_Contact';
import Page_Pricing from './Components/Page_Pricing';
import Page_GetStarted from './Components/Page_GetStarted';
import Footer from './Components/Footer';
import Page_Terms from './Components/Page_Terms';
import Page_PrivacyPolicy from './Components/Page_PrivacyPolicy';


    

function App() {
  return (
    <div className="container mx-auto mb-8 px-8 max-w-screen-lg">
       <div className="">
        <HamburgerMenu/>
        <div className="mt-10">
          <BrowserRouter>
          <Routes>
            <Route path="/"  element={<Page_Index/>} />
            <Route path="/pricing" element={<Page_Pricing/>} />
            <Route path="/getstarted" element={<Page_GetStarted/>} />
            <Route path="/contact" element={<Page_Contact/>} />
            <Route path="/terms" element={<Page_Terms/>} />
            <Route path="/privacypolicy" element={<Page_PrivacyPolicy/>} />
          </Routes>
          </BrowserRouter>
        </div>
      </div>
    <Footer/>
    </div>
  );
}

export default App;
